import Drupal from 'drupal';

(function(Drupal) {
  Drupal.behaviors.videoPlayer = {
    attach: function(context) {
      var elem = context.querySelector('.video-js');
      if (elem) {
        const videoPlayer = videojs(context.querySelector('.video-js'));
        videoPlayer.aspectRatio('16:9');
        videoPlayer.ready(function() {
          this.addClass('video-ready');
        });
      }
    },
  };
})(Drupal);
